import React, {useContext, Suspense} from 'react';
import Header from '@components/Header';
import Footer from '@components/Footer';
import AppContext from '@context/AppContext';
import Loader from '@components/Loader';

const MainPage = React.lazy(() => import('@components/MainPageComponent'));

export default function NewRequest() {
    const {defs} = useContext(AppContext);

    return (
        <div className='pageContainer'>
            <Header menuItems={defs.menu} onLogin={() => {}} />

            <div className='pageContent'>
                <Suspense fallback={<Loader />}>
                    <MainPage />
                </Suspense>
            </div>

            <Footer footerItems={[]} fromContext={true} />
        </div>
    );
}
